import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { FormsModule } from '@angular/forms';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import { VivaInputModule } from 'src/app/controls/viva-input/viva-input.module';
import { VivaPhoneInputModule } from 'src/app/controls/viva-phone-input/viva-phone-input.module';
import { VivaSelectModule } from '../controls/viva-select/viva-select.module';
import { VivaToggleModule } from '../controls/viva-toggle/viva-toggle.module';
import { VivaDateInputModule } from '../controls/viva-date-input/viva-date-input.module';
import { VivaSpinnerModule } from '../controls/viva-spinner/viva-spinner.module';
import { VivaChatModule } from '../controls/viva-chat/viva-chat.module';
import { VivaInfoPopupModule } from '../controls/viva-info-popup/viva-info-popup.module';
import { VivaQuestionPopupModule } from '../controls/viva-question-popup/viva-question-popup.module';
import { VivaTextAreaModule } from '../controls/viva-text-area/viva-text-area.module';
import { VivaLineChartModule } from '../controls/viva-line-chart/viva-line-chart.module';
import { VivaErrorPopupModule } from '../controls/viva-error-popup/viva-error-popup.module';
import { VivaWarningPopupModule } from '../controls/viva-warning-popup/viva-warning-popup.module';
import { VivaPermissionPopupModule } from '../controls/viva-permission-popup/viva-permission-popup.module';
import { VivaBackButtonModule } from '../controls/viva-back-button/viva-back-button.module';
import { LocalizedDatePipe } from './pipes/localized-date.pipe';


@NgModule({
	imports: [
		CommonModule,
		RouterModule,
		IonicModule,
		FormsModule,
		TranslatePipe,
		TranslateDirective,
		VivaInputModule,
		VivaPhoneInputModule,
		VivaToggleModule,
		VivaSelectModule,
		VivaDateInputModule,
		VivaSpinnerModule,
		VivaChatModule,
		VivaInfoPopupModule,
		VivaPermissionPopupModule,
		VivaQuestionPopupModule,
		VivaWarningPopupModule,
		VivaErrorPopupModule,
		VivaTextAreaModule,
		VivaLineChartModule,
		VivaBackButtonModule,
		LocalizedDatePipe,
	],
	exports: [FormsModule,
		TranslatePipe,
		TranslateDirective,
		VivaInputModule,
		VivaPhoneInputModule,
		VivaToggleModule,
		VivaSelectModule,
		VivaDateInputModule,
		VivaSpinnerModule,
		VivaChatModule,
		VivaInfoPopupModule,
		VivaPermissionPopupModule,
		VivaQuestionPopupModule,
		VivaWarningPopupModule,
		VivaErrorPopupModule,
		VivaTextAreaModule,
		VivaLineChartModule,
		VivaBackButtonModule,
		LocalizedDatePipe,
	],
})
export class SharedModule {}
